import React, { useState, useRef } from 'react';

// Drag files from the desktop / Finder / Outlook onto this box. PDFs and
// photos only; anything else is ignored. Works next to the normal file button.
const OK = (f) => /^(application\/pdf|image\/)/i.test(f.type || '') || /\.(pdf|jpe?g|png|heic|heif|webp)$/i.test(f.name || '');

export default function DropZone({ onFiles, disabled = false, label = 'Drop files here', className = '', style, children }) {
  const [over, setOver] = useState(false);
  const depth = useRef(0);
  const has = (e) => Array.from((e.dataTransfer && e.dataTransfer.types) || []).includes('Files');
  return (
    <div
      className={`tmw-drop${over ? ' is-over' : ''} ${className}`}
      style={style}
      data-testid="dropzone"
      onDragEnter={(e) => { if (disabled || !has(e)) return; e.preventDefault(); depth.current += 1; setOver(true); }}
      onDragOver={(e) => { if (disabled || !has(e)) return; e.preventDefault(); e.dataTransfer.dropEffect = 'copy'; }}
      onDragLeave={() => { depth.current = Math.max(0, depth.current - 1); if (!depth.current) setOver(false); }}
      onDrop={(e) => {
        if (disabled) return;
        e.preventDefault(); depth.current = 0; setOver(false);
        const files = Array.from((e.dataTransfer && e.dataTransfer.files) || []).filter(OK);
        if (files.length) onFiles(files);
      }}
    >
      {children}
      {over && <div className="tmw-drop-hint" aria-hidden="true">{label}</div>}
    </div>
  );
}
